module.exports = __webpack_public_path__ + "img/UI_SSL_yuanbao_03_aad113ec8.png";